<template>
	<section class="container-edit">
		<div class="container-account">
			<div class="user-actions">
				<feather class="user-icon" type="user" size="60" />
				<div class="name-box">
					<h1 class="title-user">@{{ userData.usuario }}</h1>
					<div>
						<b-button class="button-user" size="is-small" type="is-primary">
							Mudar Avatar
						</b-button>
					</div>
				</div>
			</div>
		</div>
		<div class="box-info">
			<b-field grouped>
				<b-field custom-class="is-small" class="box-select-user" expanded label="Usuário">
					<b-input v-model="userData.usuario" icon="account" expanded />
				</b-field>
				<b-field custom-class="is-small" class="box-select-user" expanded label="Status">
					<b-select
						v-model="userData.status"
						expanded
						placeholder="Selecione um status"
						icon="chart-bar"
					>
						<option :value="1" selected>Ativo</option>
						<option :value="0">Inativo</option>
					</b-select>
				</b-field>
			</b-field>
			<!--  <b-field grouped>
        <b-field
          custom-class="is-small"
          class="box-select-user"
          expanded
          label="Cargo"
        >
          <b-select
            v-model="userData.per_criausuadm"
            expanded
            placeholder="Selecione um cargo"
            icon="shield-star-outline"
          >
            <option :value="1">
              Administrador
            </option>
            <option :value="2">
              Usuário
            </option>
            <option :value="3">
              Gestor
            </option>
          </b-select>
        </b-field>
        <b-field
          class="box-select-user"
          label="Departamento"
          expanded
          custom-class="is-small"
        >
          <b-select
            v-model="userData.departamento"
            expanded placeholder="Selecione um departamento"
            icon="package-variant-closed"
          >
            <option value="1">
              Gestão
            </option>
            <option value="2">
              Vendas
            </option>
            <option value="3">
              TI
            </option>
            <option value="4">
              Desenvolvimento
            </option>
          </b-select>
        </b-field>
      </b-field> -->
			<div class="container-password">
				<div class="left-side-box">
					<b-field class="box-select-user-pass" label="Senha" expanded custom-class="is-small">
						<b-input v-model="password" type="password" icon="lock" expanded />
					</b-field>
					<b-field
						class="box-select-user-pass"
						label="Confirmar Senha"
						expanded
						custom-class="is-small"
					>
						<b-input v-model="userData.confirmpass" type="password" icon="lock" expanded />
					</b-field>
				</div>
				<div class="right-side-box">
					<h1 class="password-rules">A sua senha deve conter:</h1>

					<h1 class="password-rules">
						<feather
							v-if="passwordValidation.isLengthValid"
							class="feather-check"
							type="check"
							size="15"
						/>
						Pelo menos 8 caracteres.
					</h1>

					<h1 class="password-rules">
						<feather
							v-if="passwordValidation.isUpperValid"
							class="feather-check"
							type="check"
							size="15"
						/>
						Pelo menos um caractere maiúsculo (A-Z);
					</h1>

					<h1 class="password-rules">
						<feather
							v-if="passwordValidation.isLowerValid"
							class="feather-check"
							type="check"
							size="15"
						/>
						Pelo menos um caractere minúsculo (a-z);
					</h1>

					<h1 class="password-rules">
						<feather
							v-if="passwordValidation.isNumericValid"
							class="feather-check"
							type="check"
							size="15"
						/>
						Pelo menos um caractere númerico (0-9);
					</h1>

					<h1 class="password-rules">
						<feather
							v-if="passwordValidation.isSpecialValid"
							class="feather-check"
							type="check"
							size="15"
						/>
						Pelo menos um caractere especial (*, @, !, $, %, ...);
					</h1>
				</div>
			</div>
		</div>
		<div class="roles-grapics">
			<div class="roles-title">
				<feather type="user" size="17px" />
				<h1 class="roles-user-title">Permissões</h1>
			</div>
			<div>
				<b-table :data="provisorydata">
					<b-table-column v-slot="props" field="menu" label="Tipo">
						<h1>{{ props.row.menu }}</h1>
					</b-table-column>
					<b-table-column v-slot="props" field="read" label="Status" centered>
						<b-checkbox v-model="props.row.status" />
					</b-table-column>
				</b-table>

				<b-table v-if="1 != 1" :data="data">
					<b-table-column v-slot="props" field="menu" label="Menu">
						<h1>{{ props.row.menu }}</h1>
					</b-table-column>
					<b-table-column v-slot="props" field="read" label="Leitura" centered>
						<b-checkbox v-model="props.row.read" />
					</b-table-column>
					<b-table-column v-slot="props" field="edit" label="Edição" centered>
						<b-checkbox v-model="props.row.edit" />
					</b-table-column>
					<b-table-column v-slot="props" field="create" label="Criação" centered>
						<b-checkbox v-model="props.row.create" />
					</b-table-column>
					<b-table-column v-slot="props" field="delete" label="Apagar" centered>
						<b-checkbox v-model="props.row.delete" />
					</b-table-column>
				</b-table>
			</div>
		</div>
		<div class="buttons-changes">
			<b-button class="buttons-changes-bt" size="is-small" type="is-primary" @click="newUser()">
				Adicionar Usuário
			</b-button>
			<b-button class="buttons-changes-bt" size="is-small" type="is-danger" outlined>
				Cancelar
			</b-button>
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';

export default {
	name: 'NewAdmUser',
	mixins: [global],
	data() {
		return {
			dados: [],
			passwordValidation: {},
			password: '',
			userData: { status: 1 },
			provisorydata: [
				{
					menu: 'Permissão para alterar administradores',
					status: false,
					menuname: 'per_altusuadm',
				},
				{
					menu: 'Permissão para criar administradores',
					status: false,
					menuname: 'per_criausuadm',
				},
			],
			data: [
				{
					menu: 'pagamento',
					read: true,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'usuário',
					read: false,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'cartão',
					read: true,
					edit: true,
					create: false,
					delete: true,
				},
				{
					menu: 'pedidos',
					read: true,
					edit: false,
					create: true,
					delete: false,
				},
				{
					menu: 'relatórios',
					read: false,
					edit: false,
					create: true,
					delete: false,
				},
			],
			name: '',
			changePassword: 'Não',
		};
	},
	watch: {
		password(pass) {
			this.verifyPassword(pass);
		},
	},
	activated() {
		this.$store.dispatch('setModalCondPagamento', false);
	},
	created() {
		this.getUsers();
	},
	methods: {
		verifyPassword(password) {
			this.passwordValidation = this.passwordValid(
				password,
				{
					strUpper: { min: 1 },
					strLower: { min: 1 },
					strLength: { min: 8 },
					specialChar: { min: 1 },
					srtNumber: { min: 1 },
				},
				this.userData.confirmpass
			);
		},
		async getUsers() {
			this.isloading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.ADM_USUARIOS}`, {
					offset: 0,
					limit: 1000,
				})
				.then((response) => {
					if (response) {
						this.dados = response.data.usuarios;
					}
				})
				.catch(() => {
					this.isloading = false;
				});
		},
		async newUser() {
			let isIndenticUsers = 0;
			this.dados.map((usuario) => {
				if (usuario.usuario === this.userData.usuario) {
					isIndenticUsers += 1;
				}
				return true;
			});
			if (isIndenticUsers <= 0) {
				const {
					isUpperValid,
					isLowerValid,
					isLengthValid,
					isSpecialValid,
					isNumericValid,
				} = this.passwordValidation;

				if (this.password === this.userData.confirmpass) {
					if (isUpperValid && isLowerValid && isLengthValid && isSpecialValid && isNumericValid) {
						this.userData.per_criausuadm = Number(this.provisorydata[1].status);
						this.userData.per_altusuadm = Number(this.provisorydata[0].status);
						this.userData.senha = this.password;
						await ecAxios
							.connection()
							.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.ADM_USUARIO_SALVAR}`, this.userData)
							.then((response) => {
								if (response.data.error === 0) {
									this.$store.dispatch('setUpdateAdmUserTable', true);
									if (window.history.length > 1) {
										this.$router.go(-1);
									} else {
										this.$router.push('/');
									}
								}
							})
							.catch((e) => {
								this.$buefy.notification.open({
									message: e,
									type: 'is-danger',
								});
							});
					} else {
						this.$buefy.notification.open({
							message: 'As senhas não cumprem os requisitos recomendados!',
							type: 'is-danger',
						});
					}
				} else {
					this.$buefy.notification.open({
						message: 'As senhas não coincidem! , tente preencher novamente com a senha correta',
						type: 'is-danger',
					});
				}
			} else {
				this.$buefy.notification.open({
					message: 'Já existe usuário cadastrado com esse nome',
					type: 'is-danger',
				});
			}
		},
		goBack() {
			if (window.history.length > 1) {
				this.$router.go(-1);
			} else {
				this.$router.push('/');
			}
		},
	},
};
</script>

<style scoped>
.feather-check {
	color: #004b23;
}
.container-edit {
	display: flex;
	width: 100%;
	background-color: #fff;
	flex-direction: column;
	align-items: center;
	padding: 30px;
	margin-bottom: 40px;
}
.buttons-changes-bt {
	margin-top: 10px;
	margin-left: 20px;
}
.buttons-changes {
	width: 100%;
	display: flex;
	justify-content: flex-end;
}
.password-change-check {
	margin-top: 15px;
	margin-bottom: 15px;
}
.container-password {
	width: 100%;
	display: flex;
	flex-direction: row;
}
.password-rules {
	display: flex;
	margin-bottom: 6px;
	align-items: center;
}
.box-info {
	margin-top: 20px;
}
.roles-grapics {
	width: 100%;
	padding: 10px;
	margin-top: 30px;
}
.container-account {
	width: 100%;
}
.left-side-box {
	width: 50%;
}
.right-side-box {
	width: 50%;
	padding: 10px;
}
.roles-title {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}
.roles-user-title {
	margin-left: 6px;
}
.box-info {
	width: 100%;
}
.button-user {
	margin-right: 10px;
}
.box-select-user {
	width: 50%;
	font-size: 14px;
}
.box-select-user-pass {
	width: 100%;
	font-size: 14px;
}
.user-actions {
	display: flex;
	align-items: center;
}
.user-icon {
	padding: 10px;
	margin-right: 20px;
	background-color: #0b090a17;
	border-radius: 10px;
	color: #0b090a;
}
.name-box {
	display: flex;
	flex-direction: column;
	align-self: flex-start;
}
.title-user {
	margin-bottom: 10px;
}
.title-field {
	font-size: 12px;
}
</style>

